"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalMTCInfoWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var SupportPortalMTCInfoWidget = /** @class */ (function (_super) {
    __extends(SupportPortalMTCInfoWidget, _super);
    function SupportPortalMTCInfoWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SupportPortalMTCInfoWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        var additionalPremium = interaction === null || interaction === void 0 ? void 0 : interaction.factors.additionalPremium;
        var premiumType = interaction === null || interaction === void 0 ? void 0 : interaction.factors.premiumType;
        var uiState = interaction === null || interaction === void 0 ? void 0 : interaction.uistate;
        var policyHasNcdImpactedClaims = false;
        var cancellationFeeCharged = false;
        if (uiState.cancellationFeeCharged != undefined) {
            cancellationFeeCharged = uiState.cancellationFeeCharged;
        }
        if (uiState.policyHasNcdImpactedClaims != undefined) {
            policyHasNcdImpactedClaims = uiState.policyHasNcdImpactedClaims;
        }
        return (React.createElement("div", { className: "text-group" },
            React.createElement("div", { className: "inner-content font-weight-light" },
                React.createElement("span", null, "Additional Premium: "),
                React.createElement("span", null, (0, commonFunctions_1.getAmountToDisplay)(additionalPremium))),
            React.createElement("div", { className: "inner-content font-weight-light" },
                React.createElement("span", null, "Refund: "),
                React.createElement("span", null, (0, commonFunctions_1.getAmountToDisplay)(this.getCancellationReturnPremium(interaction)))),
            React.createElement("div", { className: "inner-content font-weight-light" },
                React.createElement("span", null, "Policy has impacted claims: "),
                React.createElement("span", null, policyHasNcdImpactedClaims ? "true" : "false")),
            React.createElement("div", { className: "inner-content font-weight-light" },
                React.createElement("span", null, "Cancellation Fee Charged: "),
                React.createElement("span", null, cancellationFeeCharged ? "true" : "false")),
            React.createElement("div", { className: "inner-content font-weight-light" },
                React.createElement("span", null, "premiumType: "),
                React.createElement("span", null, premiumType))));
    };
    SupportPortalMTCInfoWidget.prototype.getCancellationReturnPremium = function (interaction) {
        var _a;
        var cancellationReasonCode = (_a = interaction === null || interaction === void 0 ? void 0 : interaction.cancellationReasonInfo) === null || _a === void 0 ? void 0 : _a.cancellationReasonCode;
        if (cancellationReasonCode && (cancellationReasonCode == 'FRAUD_RETAIN_PREMIUM_AND_SUPPRESS_DOCUMENTS' || cancellationReasonCode == 'FRAUD_WITHHOLD_REFUND')) {
            return 0;
        }
        return interaction === null || interaction === void 0 ? void 0 : interaction.factors.returnPremium;
    };
    return SupportPortalMTCInfoWidget;
}(plugin_journey_1.WidgetBase));
exports.SupportPortalMTCInfoWidget = SupportPortalMTCInfoWidget;
//# sourceMappingURL=SupportPortalMTCInfoWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/supportPortal/SupportPortalMTCInfoWidget.js
// module id = 3674
// module chunks = 0